export default __webpack_public_path__ + "static/media/640_dummy2016-schmuck01-de-mobile.53156459.png";